import {useLazyGetCountriesQuery} from 'components/customer/Auth/store/accountSlice';
import {useNotificationContext} from 'contexts/NotificationContext';
import {useCallback} from 'react';
import {genericMessageHandler} from 'shared/helpers';

export const useCountryHelper = () => {
    const {notify} = useNotificationContext();
    const [getCountries] = useLazyGetCountriesQuery();

    const getCountryCode = useCallback((country: string) => {
        switch (country) {
            case 'New Zealand':
                return 'NZ';
            case 'United States':
                return 'US';
            case 'Australia':
            default:
                return 'AU';
        }
    }, []);

    const getStateName = useCallback(
        async (countryName: string, stateId: string) => {
            try {
                const {data: countries, isError} = await getCountries();

                if (isError) {
                    throw new Error();
                }

                if (countries) {
                    const countryData = countries.find(
                        (country) => country.name == countryName
                    );

                    if (countryData) {
                        const state = countryData?.states.find(
                            (state) => state.id == stateId
                        );

                        if (state) {
                            return state.name;
                        }
                    }
                }

                return false;
            } catch (e) {
                genericMessageHandler(notify, {
                    message:
                        'Could not get country info. please try again later',
                });

                return false;
            }
        },
        []
    );

    return {
        getCountryCode,
        getStateName,
    };
};
